/* unplugin-vue-components disabled */import script from "./HeaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderView.vue?vue&type=script&setup=true&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=9d132454&lang=css"

const __exports__ = script;

export default __exports__